import React, { Fragment, useState, useEffect } from "react";
import HealthService from "./HealthService/HealthService";
import ConfigService from "./ConfigService/ConfigService";
import SystemNotificationService from "./SystemNotificationService/SystemNotificationService";
import ApplicationProfileService from "./ApplicationProfile/ApplicationProfileService";
import StatusCardService from "./StatusCardService/StatusCardService";
import EcoSettingService from "./EcoSettingService/EcoSettingService";
import EventLookupService from "./EventLookupService/EventLookupService";
import DynamicSpriteService from "./DynamicSpriteService/DynamicSpriteService";
import SupportService from "./SupportService/SupportService";
import DuressService from "./DuressService/DuressService";

import * as actionCreators from "./servicesActions.js";
import { useSelector, useDispatch, shallowEqual } from "react-redux";
import ScrollbarService from "./ScrollbarService/ScrollbarService";
import EvacuationAccountabilityService from "./EvacuationAccountabilityService/EvacuationAccountabilityService.jsx";

const Services = ({ children }) => {
	const dispatch = useDispatch();
	const { servicesReady } = actionCreators;

	const rootKeys = useSelector(state => Object.keys(state), shallowEqual);

	const isServiceEnabled = serviceKey => {
		// Assumes the Redux state has a root-level key for each service
		return rootKeys.includes(serviceKey);
	};

	const [configReady, setConfigReady] = useState(false);
	const [applicationProfileReady, setApplicationProfileReady] = useState(false);

	useEffect(() => {
		if (configReady && applicationProfileReady) {
			dispatch(servicesReady());
		}
	}, [configReady, applicationProfileReady]);

	return (
		<Fragment>
			{isServiceEnabled("systemHealth") && <HealthService />}
			{isServiceEnabled("clientConfig") && <ConfigService setReady={() => setConfigReady(true)} />}
			{isServiceEnabled("application") && (
				<ApplicationProfileService setReady={() => setApplicationProfileReady(true)} />
			)}
			{isServiceEnabled("systemNotifications") && <SystemNotificationService />}
			{isServiceEnabled("statusCards") && <StatusCardService />}
			{isServiceEnabled("ecoSettings") && <EcoSettingService />}
			{isServiceEnabled("eventLookups") && <EventLookupService />}
			{isServiceEnabled("duressStatus") && <DuressService />}
			{<DynamicSpriteService />}
			{isServiceEnabled("supportService") && <SupportService />}
			{isServiceEnabled("evacuationAccountability") && <EvacuationAccountabilityService />}

			{<ScrollbarService />}
			{/* {isServiceEnabled("vicadsVideo") && <VicadsVideoService />} */}
			{children}
		</Fragment>
	);
};

export default Services;
